import type { PanelWidth } from '../../split-layout/width-utils.js';
import type { LayoutMode } from '../details-layout/DetailsLayoutContext.js';

export const sidebarDefaults: {
  defaultWidth: PanelWidth;
  minWidth: PanelWidth;
  maxWidth: PanelWidth;
  resizable: boolean;
  defaultCollapsed: boolean;
  breakpoint: number;
} = {
  defaultWidth: '15%',
  minWidth: 200,
  maxWidth: '50%',
  resizable: true,
  defaultCollapsed: false,
  breakpoint: 960,
};

export const contentDefaults: { minWidth: PanelWidth } = {
  minWidth: 0,
};

export const detailsDefaults: {
  minWidth: PanelWidth;
  maxWidth: PanelWidth;
  defaultWidth: PanelWidth;
  resizable: boolean;
  defaultCollapsed: boolean;
  defaultLayout: LayoutMode;
  breakpoint: number;
} = {
  minWidth: 320,
  maxWidth: '50%',
  defaultWidth: '25%',
  resizable: true,
  defaultCollapsed: false,
  defaultLayout: 'split',
  breakpoint: 600,
};
